// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  FIFTEEN_MINUTES_MS,
  FIVE_MINUTES_MS,
} from '@/utilities/time-constants';

/** Dropdown and autocomplete reference data stays cached while users work and always refetches when they return to the tab */
export const REFERENCE_DATA_QUERY_OPTIONS = {
  staleTime: FIVE_MINUTES_MS,
  gcTime: FIFTEEN_MINUTES_MS,
  refetchOnWindowFocus: 'always',
} as const;
